
<template>
  <div>
        <Contact :formURL="'b1205b07-b603-4897-920c-30a991cd3e81'"/>
  </div>
</template>

<script>
import Contact from './Contact.vue'

export default {
  components: {Contact}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Winkia.vue